module.exports = __webpack_public_path__ + "media/src/images/olympiads/mathematics-7494e02f2116070ccb74dc88e1fdd483.svg";